import {Component} from '@angular/core';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';

@Component({
  selector: 'dcp-login-component',
  templateUrl: './dcp-login.component.html',
})
export class DcpLoginComponent {

  constructor(
    public authService: DcpAuthService
  ) {
    this.authService.login('/');
  }
}
